var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-view"},[(_vm.category)?[_c('h2',[_vm._v(_vm._s(_vm.category.name))]),(_vm.category)?_c('app-template-index',{attrs:{"category":_vm.category}}):_vm._e()]:_c('p',[_vm._v("Loading...")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }